import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import { config } from "../services/runtimeConfig";

/**
 * NOTE: only the top-level nav/dashboard/actions/common keys are
 * translated as a working framework (per the "English/Spanish/French"
 * requirement) -- most page-level copy in this codebase is still plain
 * English strings, not yet run through t(). Extending coverage means
 * pulling more strings into locales/*.json and swapping literals for
 * t("...") calls page by page.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, es: { translation: es }, fr: { translation: fr } },
    fallbackLng: "en",
    supportedLngs: config.supportedLanguages,
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

export default i18n;
